const RESOURCE_COPY_DATA_TYPE = "fabric/resource-ids";

export { RESOURCE_COPY_DATA_TYPE };
//# sourceMappingURL=constants.js.map
